document.addEventListener("DOMContentLoaded", function () {
  const mainProductImage = document.getElementById("main-product-image");
  const mainProductImages = document.querySelectorAll(
    ".product__images_image--picture, .product__images_image"
  );

  // Select main page thumbnails (outside the modal)
  const mainPageThumbnails = document.querySelectorAll(
    ".product__thumbnails:not(#modal-thumbnails) .product__thumbnails_image"
  );

  const modal = document.getElementById("imageModal");
  const modalMainImageContainer = document.getElementById(
    "modal-main-product-image"
  );
  const modalThumbnailsContainer = document.getElementById("modal-thumbnails");
  const closeModal = document.getElementById("closeModal");

  let modalThumbs = [];
  if (modalThumbnailsContainer) {
    modalThumbs = modalThumbnailsContainer.querySelectorAll(
      ".product__thumbnails_image"
    );
  }

  function openModal(clickedItem) {
    if (!modal) return;

    document.documentElement.style.overflow = "hidden";

    modal.style.display = "flex";
    modal.style.opacity = "0";

    // Lazy-load modal images.
    const modalImages = modalMainImageContainer.querySelectorAll(
      "img.modal-product-image"
    );
    modalImages.forEach((img) => {
      if (!img.getAttribute("src")) {
        img.setAttribute("src", img.getAttribute("data-src"));
      }
    });

    // Get the index of the clicked item.
    let selectedIndex = parseInt(clickedItem.getAttribute("data-index"), 10);
    if (isNaN(selectedIndex)) {
      selectedIndex = parseInt(clickedItem.getAttribute("data-position"), 10);
    }

    // Update active state for modal thumbnails.
    modalThumbs.forEach((thumb, index) => {
      thumb.classList.toggle(
        "product__thumbnails_image-active",
        index === selectedIndex
      );
    });

    // Scroll modal main image container to the selected image.
    const containerWidth = modalMainImageContainer.clientWidth;
    modalMainImageContainer.scrollLeft = containerWidth * selectedIndex;

    // Ensure the active modal thumbnail is in view.
    if (modalThumbs[selectedIndex]) {
      modalThumbs[selectedIndex].scrollIntoView({
        block: "nearest",
        inline: "center",
      });
    }

    modal.style.opacity = "1";
  }

  mainProductImages.forEach((item) => {
    item.addEventListener("click", () => openModal(item));
  });

  // Close modal and restore body scroll.
  closeModal?.addEventListener("click", () => {
    modal.style.display = "none";
    document.documentElement.style.overflow = "unset";
  });

  // Update active thumbnail when scrolling main product images.
  mainProductImage.addEventListener("scroll", () => {
    const selectedIndex = Math.floor(
      mainProductImage.scrollLeft / mainProductImage.clientWidth
    );
    mainPageThumbnails.forEach((thumb, index) => {
      thumb.classList.toggle(
        "product__thumbnails_image-active",
        index === selectedIndex
      );
    });
    // Scroll the active main page thumbnail into view.
    if (mainPageThumbnails[selectedIndex]) {
      mainPageThumbnails[selectedIndex].scrollIntoView({
        block: "nearest",
        inline: "center",
      });
    }
  });

  // Update active thumbnail when scrolling modal main images.
  modalMainImageContainer?.addEventListener("scroll", () => {
    const selectedIndex = Math.floor(
      modalMainImageContainer.scrollLeft / modalMainImageContainer.clientWidth
    );
    modalThumbs.forEach((thumb, index) => {
      thumb.classList.toggle(
        "product__thumbnails_image-active",
        index === selectedIndex
      );
    });
    // Scroll the active modal thumbnail into view.
    if (modalThumbs[selectedIndex]) {
      modalThumbs[selectedIndex].scrollIntoView({
        block: "nearest",
        inline: "center",
      });
    }
  });

  // Modal thumbnail click handling.
  modalThumbs.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      const position = thumbnail.getAttribute("data-position");
      if (position === null) return;

      modalThumbs.forEach((thumb) =>
        thumb.classList.remove("product__thumbnails_image-active")
      );
      thumbnail.classList.add("product__thumbnails_image-active");

      const modalImages = modalMainImageContainer.querySelectorAll(
        ".modal-product-image"
      );
      if (modalImages[position]) {
        modalImages[position].scrollIntoView({
          block: "nearest",
          inline: "center",
        });
      }
      thumbnail.scrollIntoView({ block: "nearest", inline: "center" });
    });
  });

  // Main page thumbnail click interaction.
  mainPageThumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      const position = thumbnail.getAttribute("data-position");
      if (position === null) return;

      // Remove active class from the current active thumbnail.
      document
        .querySelector(".product__thumbnails_image-active")
        ?.classList.remove("product__thumbnails_image-active");
      thumbnail.classList.add("product__thumbnails_image-active");

      // Scroll to the corresponding main product image.
      const mainImages = document.querySelectorAll(
        ".product__images_image--picture, .product__images_image"
      );

      Array.from(mainImages)
        .find((img) => img.getAttribute("data-position") === position)
        .scrollIntoView({
        block: "nearest",
        inline: "start",
        behavior: "smooth",
      });
    });
  });
});
